import {
  localeFragment,
} from "./fragments.gql"

export default `query GlobalConfigQuery($locale: SiteLocale) {
  globalConfig(${localeFragment}) {
    flags {
      enabled
      flagId
    }
    configItems {
      slug
      valueBoolean
      valueDate
      valueDatetime
      valueFloat
      valueInt
      valueJson
      valueString
      type: configItemType
    }
  }
}`
